const userColors: string[] = [
  "#ed553b",
  "#f2b133",
  "#47ab6c",
  "#09d3e6",
  "#23638c",
  "#f52281",
  "#7dc161",
  "#f39d03",
  "#3bafbd",
  "#a51f6a",
  "#bda400",
  "#f08973",
  "#f7d969",
];

// TODO: rather than randomly assigning a color based on the hex representation of the user id,
// we should assign colors sequentially from the userColors array to guarantee no duplicates.
export const getUserColor = (userId: string): string =>
  userColors[
    userId
      .split("")
      .map((char) => char.charCodeAt(0))
      .reduce((acc, l) => acc + l, 0) % userColors.length
  ];
